import * as $ from 'jquery';
import '../__vendors/slick.min'
import { scrollToElementById } from '../../ts/lib/layout/scroll-to-section';

const initBenefitSlider = () => {
    $('.benefits-slider__slick').each(function () {
        $(this).slick({
            arrows: false,
            infinite: true,
            slidesToShow: 5,
            slidesToScroll: 1,
            centerMode: true,
            speed: 800,
            autoplay: true,
            dots: false,
            autoplaySpeed: 3000,
            draggable: false,
            pauseOnHover: false,
            pauseOnFocus: false,
            responsive: [
                { breakpoint: 1199, settings: { slidesToShow: 3 } },
                { breakpoint: 992, settings: { slidesToShow: 2 } },
                { breakpoint: 768, settings: { slidesToShow: 2, variableWidth: true } },
                { breakpoint: 576, settings: { slidesToShow: 1, dots: true, variableWidth: true } }
            ]
        }).on('touchend touchcancel touchmove', function () {
            $(this).slick('slickPlay');
        });
    });

    $('.content-slider__arrows .arrow-prev').click(function () {
        $(this).closest('.content-slider').find('.benefits-slider__slick').slick('slickPrev');
    });

    $('.content-slider__arrows .arrow-next').click(function () {
        $(this).closest('.content-slider').find('.benefits-slider__slick').slick('slickNext');
    });
};

const initVideoSlider = () => {
    $('.video-slider__slick').each(function () {
        $(this).slick({
            arrows: false,
            infinite: true,
            slidesToShow: 4,
            slidesToScroll: 1,
            centerMode: true,
            speed: 800,
            autoplay: true,
            dots: false,
            autoplaySpeed: 3000,
            draggable: false,
            pauseOnHover: false,
            pauseOnFocus: false,
            responsive: [
                { breakpoint: 1199, settings: { slidesToShow: 3 } },
                { breakpoint: 992, settings: { slidesToShow: 2 } },
                { breakpoint: 768, settings: { slidesToShow: 2, variableWidth: true } },
                { breakpoint: 576, settings: { slidesToShow: 1, dots: true, variableWidth: true } }
            ]
        }).on('touchend touchcancel touchmove', function () {
            $(this).slick('slickPlay');
        });
    });

    $('.content-slider__arrows .arrow-prev').click(function () {
        $(this).closest('.content-slider').find('.video-slider__slick').slick('slickPrev');
    });

    $('.content-slider__arrows .arrow-next').click(function () {
        $(this).closest('.content-slider').find('.video-slider__slick').slick('slickNext');
    });
};

$(document).ready(() => {
    initBenefitSlider();
    initVideoSlider();
});

document.addEventListener('DOMContentLoaded', function() {
    const slider = document.querySelector('.tabs-buttons');
    let isDown = false;
    let startX;
    let scrollLeft;

    slider.addEventListener('mousedown', (e) => {
        isDown = true;
        slider.classList.add('active');
        startX = e.pageX - slider.offsetLeft;
        scrollLeft = slider.scrollLeft;
    });

    slider.addEventListener('mouseleave', () => {
        isDown = false;
        slider.classList.remove('active');
    });

    slider.addEventListener('mouseup', () => {
        isDown = false;
        slider.classList.remove('active');
    });

    slider.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - slider.offsetLeft;
        const walk = (x - startX) * 2;
        slider.scrollLeft = scrollLeft - walk;
    });
});

document.addEventListener('DOMContentLoaded', function() {
    const tabs = document.querySelectorAll('.tab-button');
    tabs.forEach(function(tab) {
        tab.addEventListener('click', function() {

            let activeButton = document.querySelector('.tab-button.active-button');
            if (activeButton) {
                activeButton.classList.remove('active-button');
            }
            this.classList.add('active-button');

            let tabId = this.getAttribute('data-tab');
            const activeTab = document.querySelector('.tab-content.active');
            if (activeTab) {
                activeTab.classList.remove('active');
            }
            let newActiveTab = document.getElementById(tabId);
            newActiveTab.classList.add('active');
        });
    });
});

window.onload = function() {
    const eRecruiterScript = document.querySelector('#skk_container_fbc1691993bc4076b66460ad411a5556');
    const newLocation = document.querySelector('#erecruiter-sdk');
    const header = document.querySelector('#erecruiter-header');
    if (eRecruiterScript && newLocation && header) {
        newLocation.insertBefore(eRecruiterScript, header.nextSibling);
    }

    let visibleOffersCount = 6;

    function updateOffersDisplay() {
        const offers = document.querySelectorAll('.skk_offers_tbody tr');
        offers.forEach((offer, index) => {
            offer.style.display = index < visibleOffersCount ? '' : 'none';
        });

        updateShowMoreButtonVisibility(offers);
        hidePreloader();
    }

    function updateShowMoreButtonVisibility(offers) {
        const showMoreBtn = document.getElementById('showMoreBtn');
        showMoreBtn.style.display = visibleOffersCount < offers.length - 1 ? 'block' : 'none';
    }

    function hidePreloader() {
        const preloader = document.getElementById('preloader');
        if (preloader) {
            preloader.style.display = 'none';
        }
    }

    function resetAfterFiltering() {
        visibleOffersCount = 6;
        updateOffersDisplay();
    }

    document.querySelector('.skk_filters_btn_search').addEventListener('click', function() {
        setTimeout(resetAfterFiltering, 170);
    });

    updateOffersDisplay();

    document.getElementById('showMoreBtn').addEventListener('click', function() {
        visibleOffersCount += 6;
        updateOffersDisplay();
    });
};

document.getElementById('offerts-scroll').addEventListener('click', (event) => {
    const href = event.target.getAttribute('href');
    if (href && href.startsWith('#')) {
        scrollToElementById(href.substring(1));
        event.preventDefault();
    } else {
        console.error('Href attribute is not correctly specified.');
    }
});
